import { DivConst } from 'constants/divConst';
import { DiagnosisHelper } from './diagnosisHelper';
import { QuizHelper } from './quizHelper';

export class ContentHelper {
  /**
   * コンテンツタイプ文字列を取得します
   */
  static getContentsTypeStr(contentsTypeDiv: number): string {
    switch (contentsTypeDiv) {
      case DivConst.items.contentsType.quiz.value:
        return 'quiz';
      case DivConst.items.contentsType.diagnosis.value:
        return 'diagnosis';
      default:
        return '';
    }
  }
  /**
   * コンテンツタイプ文字列（和名）を取得します
   */
  static getContentsTypeStrJpn(contentsTypeDiv: number): string {
    switch (contentsTypeDiv) {
      case DivConst.items.contentsType.quiz.value:
        return 'クイズ';
      case DivConst.items.contentsType.diagnosis.value:
        return '診断';
      default:
        return '';
    }
  }
  /**
   * コンテンツの公開URLを開きます。
   */
  static openProductionUrl(contentsCd: string, contentsTypeDiv: number): void {
    switch (contentsTypeDiv) {
      case DivConst.items.contentsType.quiz.value:
        QuizHelper.openProductionUrl(contentsCd);
        return;
      case DivConst.items.contentsType.diagnosis.value:
        DiagnosisHelper.openProductionUrl(contentsCd);
        return;
      default:
        return;
    }
  }
  /**
   * コンテンツのLINE用公開URLを開きます。
   */
  static openLineProductionUrl(contentsCd: string, contentsTypeDiv: number): void {
    switch (contentsTypeDiv) {
      case DivConst.items.contentsType.quiz.value:
        QuizHelper.openLineProductionUrl(contentsCd);
        return;
      case DivConst.items.contentsType.diagnosis.value:
        DiagnosisHelper.openLineProductionUrl(contentsCd);
        return;
      default:
        return;
    }
  }
}
